import { Component, HostBinding, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { rest } from '@directus/sdk';
import { FormGroup } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBars, faTh, faList } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'base-component',
  standalone: true,
  imports: [FontAwesomeModule],
  template: `
    <p>
      base works!
    </p>
  `,
  styleUrl: './base.component.css'
})
export class BaseComponent {
  @HostBinding('class.valid') isValid = false;

  isModalOpen: boolean = false;

  apiUrl = environment.apiUrl;
  layoutGrid = true;
  authService: any;
  faList = faList;
  faTh = faTh;
  faBars = faBars;
  protected _bgColor: string = "rgba(255, 255, 255, 1)";

  form!: FormGroup;
  print_error: string = "";


  constructor(protected router: Router) {
    this.authService = inject(AuthService);

    this.faTh = faTh;
    this.faList = faList;
  }

  changeLayout(_element: any) {

    this.layoutGrid = !this.layoutGrid;
    //disable it
    //_element.textContent = !this.layoutGrid ? "grid" : "list";
  }
  logOut() {
    this.authService.logout();
    this.router.navigate(['/']);
  }
  protected getBackgroundAlpha(_rgbaColorString: string, _alpha: number = 0.4 ): string {
    if (_rgbaColorString && _rgbaColorString != undefined && _rgbaColorString.indexOf('a') != -1) {
      var result = _rgbaColorString.replace(', 1)', ', ' + _alpha +')');
      return result;
    }
    return _rgbaColorString;
  }


  closeModal() {
    this.isModalOpen = false;
  }
  public openModal() {
    this.isModalOpen = true;
  }

  get f() {
    return this.form.controls;
  }
}
